import React from "react"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import classNames from "classnames"

import Close from "../icons/close"

const styles = theme => ({
  root: {
    position: "fixed",
    bottom: 0,
    right: 0,
    zIndex: 3,
    transition: "0.5s all linear",
  },

  closeBtnContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    background: "#1A65FF",
    width: "20px",
    height: "20px",
  },

  closeBtn: {
    width: "20px",
    height: "20px",
    verticalAlign: "unset",
    margin: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0",
  },

  // layout.jsでwindowサイズが450px以下の場合しか表示しないので、実際は機能してないCSS
  popup: {
    width: "318px",
  },
})

const FooterBannerPopup = ({ classes, showPopup, pageHasPopup, togglePopup }) => (
  <div
    className={classNames(classes.root, "footer-popup")}
    style={{
      transform: showPopup ? "translateY(5px)" : "translateY(100%)",
      display: pageHasPopup ? "block" : "none",
    }}
  >
    <div>
      <a
        href="https://keymanletter.com/executive-list/"
        target="_blank"
        rel="noopener"
      >
        <img
          alt="kdb-banner.png"
          src={require("../../images/kdb-banner-4@2x.png")}
          className={classes.popup}
        />
      </a>
    </div>
    <div className={classes.closeBtnContainer}>
      <IconButton className={classes.closeBtn} onClick={togglePopup}>
        <Close color="#FFFFFF" width="14" height="14" />
      </IconButton>
    </div>
  </div>
)

FooterBannerPopup.propTypes = {
  classes: PropTypes.object.isRequired,
  showPopup: PropTypes.bool.isRequired,
  pageHasPopup: PropTypes.bool.isRequired,
  togglePopup: PropTypes.func.isRequired,
}

export default withStyles(styles)(FooterBannerPopup)
